<template>
	<v-content>
		<transition name="loading-fade">
			<div v-if="showIndeterminate" class="global-loading" role="status" aria-live="polite">
				<div class="global-loading-card">
					<div class="global-spinner" aria-hidden="true">
						<span></span>
						<v-icon color="white">security</v-icon>
					</div>
					<div class="global-loading-copy">
						<strong>Cargando información</strong>
						<span>Estamos preparando los datos...</span>
					</div>
				</div>
			</div>
		</transition>
		<app-header
			:quantity-notifications="quantityNotifications"
			v-on:open-notifications-event="openNotificationsModal"
		/>
		<v-container fluid pa-0 class="admin-shell">
			<slot></slot>
			<footer class="admin-copyright">
				<span>© {{ currentYear }} QUIPUSOFT S.A.</span>
				<span class="copyright-separator" aria-hidden="true"></span>
				<span>Todos los derechos reservados</span>
			</footer>
			<action-sidebar
				:width="action.width"
				v-model="action.open"
				v-bind:code-action="action.code"
				v-bind:title="action.title"
				v-bind:active="action.active"
				v-bind:img-src="action.imgSrc"
				v-bind:is-loading="loading"
				v-bind:header-color="action.color">
			</action-sidebar>
		</v-container>
	</v-content>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import appHeader from '@/components/shared/app-header';

function closeNotificationsModal() {
	this.action.active = false;
	this.action.open = false;
}

function getRoutes(routes) {
	this.routes = routes;
}

function notifications() {
	const allNotifications = [];
	if (this.productsNotifications.length > 0) {
		this.productsNotifications.forEach((productNot) => {
			allNotifications.push(productNot);
		});
	}
	if (this.salesNotifications.length > 0) {
		this.salesNotifications.forEach((saleNot) => {
			allNotifications.push(saleNot);
		});
	}
	return allNotifications;
}

function openNotificationsModal() {
	this.action.active = true;
	this.action.open = true;
}

function quantityNotifications() {
	return 0;
}

function currentYear() {
	return new Date().getFullYear();
}

function toggleSidebar() {
	this.isVisible = !this.isVisible;
}

function data() {
	return {
		action: {
			active: false,
			code: 'NOT',
			open: false,
			title: 'Notificaciones',
			width: 468,
		},
		isVisible: true,
		loading: false,
		routes: [],
	};
}

function showIndeterminate() {
	return this.$store.getters.indeterminate;
}

export default {
	name: 'layout-admin',
	components: {
		actionSidebar,
		appHeader,
	},
	computed: {
		currentYear,
		showIndeterminate,
		notifications,
		quantityNotifications,
	},
	data,
	methods: {
		closeNotificationsModal,
		getRoutes,
		openNotificationsModal,
		toggleSidebar,
	},
};
</script>

<style lang="scss" scoped>
.admin-shell {
	display: flex;
	flex-direction: column;
	min-height: calc(100vh - 56px);
	padding-bottom: 34px !important;
}

.admin-copyright {
	align-items: center;
	color: #718078;
	display: flex;
	flex: 0 0 auto;
	font-size: 10px;
	gap: 8px;
	justify-content: center;
	letter-spacing: .02em;
	min-height: 34px;
	padding: 8px 16px;
	background: rgba(248, 251, 249, .97);
	border-top: 1px solid #E2ECE7;
	bottom: 0;
	left: 0;
	position: fixed;
	right: 0;
	z-index: 1;
}

.copyright-separator {
	background: #BFD5CC;
	border-radius: 50%;
	height: 3px;
	width: 3px;
}

.global-loading {
	align-items: center;
	backdrop-filter: blur(2px);
	background: rgba(238, 245, 242, .76);
	display: flex;
	inset: 56px 0 0;
	justify-content: center;
	position: fixed;
	z-index: 900;
}

.global-loading-card {
	align-items: center;
	background: rgba(255, 255, 255, .98);
	border: 1px solid #C8DDD5;
	border-radius: 16px;
	box-shadow: 0 18px 48px rgba(26, 67, 56, .2);
	display: flex;
	gap: 16px;
	min-width: 300px;
	padding: 17px 20px;
}

.global-spinner {
	align-items: center;
	background: linear-gradient(135deg, #2E6B59, #1A4338);
	border-radius: 13px;
	display: flex;
	flex: 0 0 48px;
	height: 48px;
	justify-content: center;
	position: relative;

	span {
		animation: global-spin .85s linear infinite;
		border: 2px solid rgba(255, 255, 255, .32);
		border-radius: 50%;
		border-top-color: white;
		height: 38px;
		position: absolute;
		width: 38px;
	}

	.icon { font-size: 19px; }
}

.global-loading-copy {
	display: flex;
	flex-direction: column;
	gap: 4px;

	strong {
		color: #1A4338;
		font-family: map-get($fonts, open-semibold);
		font-size: 13px;
	}

	span { color: #718078; font-size: 11px; }
}

.loading-fade-enter-active,
.loading-fade-leave-active { transition: opacity .18s ease; }
.loading-fade-enter,
.loading-fade-leave-to { opacity: 0; }

@keyframes global-spin {
	to { transform: rotate(360deg); }
}

@media (max-width: 480px) {
	.global-loading { inset: 56px 0 0; padding: 20px; }
	.global-loading-card { min-width: 0; width: 100%; }
}
</style>



// WEBPACK FOOTER //
// src/layouts/layout-admin.vue